import { c as _c } from "react/compiler-runtime";
import { type FieldPath, type FieldPathValues, type FieldValues, useWatch } from 'react-hook-form';
function useActionFormValues(names) {
  const $ = _c(2);
  let t0;
  if ($[0] !== names) {
    t0 = {
      name: names
    };
    $[0] = names;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useWatch(t0) as [...FieldPathValues<T, [...TPaths]>];
}
export function useAllActionFormValues() {
  return useWatch() as T;
}
export function withValues<TFormValues extends FieldValues>() {
  return useActionFormValues as <TPaths extends Array<FieldPath<TFormValues>>>(names: [...TPaths]) => [...FieldPathValues<TFormValues, [...TPaths]>];
}
export default useActionFormValues;